import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">常见问题解答</h2>
          <p className="mt-3 text-sm text-foreground-600">关于每日大赛黑料，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0 mt-0.5">
                    Q
                  </span>
                  {item.q}
                </h3>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed pl-9">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}